import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './EvTaskEditor.html?raw';
import _StatefulSection from '../../../../moreCore/UI/_StatefulSection/_StatefulSection';
import _uiFrameMixin from '../../../../moreCore/UI/Container/uiFrame';
import lang from 'dojo/_base/lang';
import SearchSelect from '../../../../moreCore/UI/SearchSelect/SearchSelect';
import _GlobalSelectEntityDialogsMixin from '../../../_loadingHelpers/_GlobalSelectEntityDialogsMixin';
import HintBox from '../../../../moreCore/UI/HintBox/HintBox';
import { SelectEntityDialogTypes } from "../../../../moreCore/_loadingHelpers/SelectEntityDialog";
import Edit from '../../../../moreCore/UI/Edit/Edit';
import DateTimeInput from '../../../../moreCore/UI/DateTimeInput/DateTimeInput';

class EvTaskEditor extends compose(_StatefulSection, _uiFrameMixin, _GlobalSelectEntityDialogsMixin) {
    templateString: any = template;

    //private inputDurationForerun: NumberInput;
    //private inputDurationTrailer: NumberInput;
    private inputDateForerun: MdsLax<InstanceType<typeof DateTimeInput>>;
    private inputDateTrailer: MdsLax<InstanceType<typeof DateTimeInput>>;
    private inputDatesContainer: HTMLElement;
    private inputTaskStatus: MdsLax<InstanceType<typeof SearchSelect>>;
    private inputTaskDescription: MdsLax<InstanceType<typeof SearchSelect>>;
    private inputRefAddress: MdsLax<InstanceType<typeof HintBox>>;
    private inputTaskGroup: MdsLax<InstanceType<typeof Edit>>;


    setup(entity?: EvTask, refEntity?: more.EntityAPIResultExtended) {
        let isNew: boolean;
        let title: string;

 

        if (entity) {
            isNew = false;
            entity.isNew = isNew || entity.isNew;
            this.setData(entity);
            title = `${this.translate("General_Heading_EditEvTask")} - ${entity.$Displayname}`;
        } else { 
            isNew = true;
            let newEntity: EvTask = {
                $Displayname: "",
                Classname: "",
                ID: "",
                ClassPrintname: "",
                ref_ev_planning: refEntity,
                ref_task_description: null,
                date_forerun: null,
                date_trailer: null,
                is_reserve: false,
                note: "",
                ref_task_status: null,
                ref_vt_address_backoffice: null,
                isNew: isNew
            }
            this.setData(newEntity);
            title = this.translate("General_Heading_NewEvTask");
        }

        this.createDefaultButton("ok", lang.hitch(this, this._onClickConfirm));
        this.show("dlg", title);

        this.SEDconfigCallfunction = "Webtool_API__EvTask_GetSEDConfig";
        this.inputRefAddress.setCallfunction("Webtool_API__EvTask_GetAssociatedAddresses");

        if (isNew) {
            this.disableNode(this.inputRefAddress);
        } else {
            this.inputRefAddress.addInlineButton(lang.hitch(this, this._onClickOpenSED, "selectAddress"));
        }
    }

    private _onClickConfirm() {
        let entity = this.getCurrentData();
        this.emit("confirmed", entity);
        this.close();
    }

    private _onClickOpenSED(mode: string, e: MouseEvent) {
        switch (mode) {
            case "selectAddress":
                let task = this.getAttributeValue("___root");
                let isNew = this.getAttributeValue("isNew");
                let taskDescription = this.getAttributeValue("ref_task_description");
                this.openSelectEntityDialog(e, mode, lang.hitch(this, this._onSEDResponse), null, { task: task, isNew: isNew, task_description: taskDescription }, true);
                break;
        }
    }

    private _onSEDResponse(mode: string, data: Array<string>, items: Array<SelectEntityDialogTypes.Item<any>>) {
        switch (mode) {
            case "selectAddress":
                if (items && items.length > 0) {
                    let entity = items[0].entry.data;
                    this.setAttributeValue("ref_vt_address_backoffice", entity);
                }
                break;
        }
    }

    protected _onChanged(attribute: string, value: any) {
        switch (attribute) {
            case "ref_task_description":
                let isNew = this.getAttributeValue("isNew");
                let task = this.getAttributeValue("___root");
                let taskDescription = value;

                this.inputTaskGroup.setValue(value ? value.ref_task_grp ? value.ref_task_grp.description : null : null);
                this.colorNode(this.inputTaskGroup.inputNode, value ? value.ref_task_grp ? value.ref_task_grp.coloration : null : null);

                if (isNew && value) {
                    this.inputRefAddress.addInlineButton(lang.hitch(this, this._onClickOpenSED, "selectAddress"), "sedButton");
                    this.disableNode(this.inputRefAddress, false);
                }
                if (isNew && !value) {
                    this.inputRefAddress.removeInlineButton("sedButton");
                    this.disableNode(this.inputRefAddress, true);
                }

                this.inputRefAddress.emptyAdditionalRequestParams();
                this.inputRefAddress.addAdditionalRequestParameter("task", task);
                this.inputRefAddress.addAdditionalRequestParameter("isNew", isNew);
                this.inputRefAddress.addAdditionalRequestParameter("task_description", taskDescription);

                //## FORERUN-TRAILER
                if (isNew && value) {
                    let planning = this.getAttributeValue("ref_ev_planning")
                    let taskDescription = this.getAttributeValue("ref_task_description")


                    if (!!planning && !!taskDescription) {
                        let requestParameter = {
                            evPlanningID: planning.ID,
                            taskDescriptionID: taskDescription.ID
                        }
                        this.disableNode(this.inputDatesContainer);
                        this.hourGlassStart(this.inputDatesContainer);

                        this.RequestManager.callfunction(
                            "Webtool_API_EvBooking__EvTask_CalculateTimeForerunTrailer",
                            requestParameter,
                            lang.hitch(this, this._onResponseSuccess),
                            lang.hitch(this, this._onResponseError)
                        );
                    }
                }
                //##
                break;
        }
    }
    private _onResponseSuccess(response: { newDateForerun: Date, newDateTrailer: Date }) {

        this.setAttributeValue("date_forerun", response.newDateForerun);
        this.setAttributeValue("date_trailer", response.newDateTrailer);
        this.disableNode(this.inputDatesContainer, false);
        this.hourGlassEnd(this.inputDatesContainer);
    }
    private _onResponseError(err: more.requestErrorMessage) {

        this.showToast(err.Message, "fas fa-exclamation warning");
        this.disableNode(this.inputDatesContainer, false);
        this.hourGlassEnd(this.inputDatesContainer);
    }
    protected afterSetData() {
        super.afterSetData.apply(this, arguments as any);

        let taskDescription = this.getAttributeValue("ref_task_description");
        this.inputTaskDescription.loadListValues(taskDescription, true);
        if (taskDescription && taskDescription.ref_task_grp) {
            this.colorNode(this.inputTaskGroup.inputNode, taskDescription.ref_task_grp.coloration);
        }

        let taskStatus = this.getAttributeValue("ref_task_status");
        this.inputTaskStatus.loadListValues(taskStatus, true);
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
        this.RequestManager.handleAs = "jsonWithDate";

        //this.inputDurationForerun.setNumberType("decimal");
        //this.inputDurationForerun.setPlaces(2);
        //this.inputDurationForerun.setStep("0.05");
        //this.inputDurationForerun.setUnit("min");

        //this.inputDurationTrailer.setNumberType("decimal");
        //this.inputDurationTrailer.setPlaces(2);
        //this.inputDurationTrailer.setStep("0.05");
        //this.inputDurationTrailer.setUnit("min");

        this.inputTaskDescription.setCallfunction("Webtool_API__EvTask_GetEvTaskDesctiptionListData");
        this.inputTaskStatus.setCallfunction("Webtool_API__EvTask_GetTaskStatusListData");   
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(EvTaskEditor);